module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_8023.c7d7812c.png";